import clsx from 'clsx';
import { TextInput } from '@tremor/react';
import { UseFormRegisterReturn } from 'react-hook-form';
import { authTremorTextInputRootClass } from '../authFormTremor';

interface AuthTextFieldProps {
  readonly id: string;
  readonly label: string;
  readonly type: 'text' | 'email';
  readonly autoComplete: string;
  readonly disabled: boolean;
  readonly dense?: boolean;
  readonly error?: string;
  readonly registration: UseFormRegisterReturn;
}

export function AuthTextField({
  id,
  label,
  type,
  autoComplete,
  disabled,
  dense = false,
  error,
  registration,
}: AuthTextFieldProps) {
  const errorId = `${id}-error-msg`;
  const hasError = !!error;

  return (
    <div>
      <label
        htmlFor={id}
        className={clsx(
          'block text-sm font-medium',
          dense ? 'mb-0.5' : 'mb-1',
          hasError ? 'text-red-800' : 'text-gray-700',
        )}
      >
        {label}
      </label>
      <TextInput
        id={id}
        type={type === 'email' ? 'text' : type}
        inputMode={type === 'email' ? 'email' : undefined}
        autoComplete={autoComplete}
        disabled={disabled}
        placeholder=""
        error={false}
        className={authTremorTextInputRootClass(dense, hasError)}
        aria-invalid={hasError ? true : undefined}
        aria-describedby={hasError ? errorId : undefined}
        {...registration}
      />
      {error && (
        <p id={errorId} className="mt-1 text-sm text-red-600" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
